<template>
    <b-alert
        v-bind="$attrs"
        class="important-alert"
    >
        <b-icon-exclamation-diamond class="important-icon"></b-icon-exclamation-diamond>
        <slot></slot>
    </b-alert>
</template>
<style scoped>
.important-icon {
    font-size: 26px;
    margin-right: 8px;
    margin-bottom: -3px;
}

.important-alert {
    background: #282828;
    color: #ffffff;

}

::v-deep .btn,
a {
    color: #ffffff !important;
}
</style>
<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
